PegasusTemplate.EditingController = Ember.ObjectController.extend({
  edited: null,

  image: null,

  text: null,

  didSave: function(){
    PegasusTemplate.stateMachine.send('didFinishEditing', true);
  },

  didCancel: function(){
    PegasusTemplate.stateMachine.send('didCancel');
  },

  row: function(){
    return this.get('content.row') || this.get('edited.row');
  }.property('edited.row', 'content.row')
});
